import React from 'react';
import { Tabs, Tab,  Row, Col, Card, Alert} from 'react-bootstrap';
import PaiementCotisation from './paiementCotisation';

const StatusCotisationJoueur = (props) => {




    return (
        <>
        {props.cotisation && props.cotisation.cotisationJoueur &&
            <Row>
                <Col>
                    <Tabs defaultActiveKey="status" id="uncontrolled-tab-example">
                        <Tab eventKey="status" title="État de la cotisation">
                        <Card>
                                <Card.Body>
                                    <Card.Title>État de la cotisation</Card.Title>
                                    {props.cotisation.cotisationJoueur[0].retardCotisation === 'true' && (
                                        <Alert variant="danger" className="mt-3">
                                            Attention: La cotisation est en retard !
                                            Vos accès ont été bloqués.
                                        </Alert>
                                    )}
                                    {props.cotisation.cotisationJoueur[0].retardCotisation === 'false' && props.cotisation.cotisationJoueur[0].confirmationCotisation === 'false' &&  props.cotisation.cotisationJoueur[0].date_payement === null && (
                                        <Alert variant="danger" className="mt-3">
                                            Attention: Vous devez encore payé votre cotisation
                                        </Alert>
                                    )}
                                    {props.cotisation.cotisationJoueur[0].confirmationCotisation === 'true'  && (
                                        <Alert variant="success" className="mt-3">
                                           Cotisation confirmée
                                        </Alert>
                                    )}
                                    <p>
                                        Statut de votre cotisation : <span style={{ color: props.cotisation.cotisationJoueur[0].retardCotisation === 'true' ? 'red' : 'inherit' }}>
                                            {props.cotisation.cotisationJoueur[0].retardCotisation === 'true' ? 'En retard' :
                                                props.cotisation.cotisationJoueur[0].confirmationCotisation === 'true' ? 'Paiement confirmé' :
                                                    props.cotisation.cotisationJoueur[0].date_payement === null ? 'Paiement non réalisé' :
                                                        'Paiement en attente de confirmation'}
                                        </span>
                                    </p>
                                    <p>Prix : <strong>{props.cotisation.cotisationJoueur[0].prixCotisation} €</strong></p>
                                    <p>Date de paiement maximale : <strong>{props.cotisation.cotisationJoueur[0].dateCotisation}</strong></p>
                                    {props.cotisation.cotisationJoueur[0].confirmationCotisation === 'true' && <>Date de confirmation du paiement : <strong>{props.cotisation.cotisationJoueur[0].date_payement}</strong></>}
                                    {props.cotisation.cotisationJoueur[0].confirmationCotisation === 'false' && props.cotisation.cotisationJoueur[0].date_payement !== null && <>Date de paiement (pas encore confirmé par votre coach) : <strong>{props.cotisation.cotisationJoueur[0].date_payement}</strong></>}
                                </Card.Body>
                            </Card>
                        </Tab>
                        <Tab eventKey="payment" title="Paiement" disabled={props.cotisation.cotisationJoueur[0].confirmationCotisation === 'true' || props.cotisation.cotisationJoueur[0].date_payement !== null}>
                                <PaiementCotisation userData={props.userData} cotisation={props.cotisation}/>
                        </Tab>
                    </Tabs>
                </Col>
            </Row>
        }  
        </> 
    );
};

export default StatusCotisationJoueur;
